// sales-page/src/pages/Success.jsx
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ThankYouPlan from './ThankYouPlan';
import ThankYouBadge from './ThankYouBadge';

// Success.jsx is the landing page for Stripe's success_url redirect.
// Stripe sends the buyer to /success?type=badge&session_id=...
// or /success?type=plan&session_id=...
// We read the type param and render the appropriate thank-you page.

const Success = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  if (type === 'badge') {
    return <ThankYouBadge />;
  }

  // Default to plan thank you for 'plan' type or any missing/unknown type
  return <ThankYouPlan />;
};

export default Success;